import { render } from "./RichMenuAnalyticsPanel.vue?vue&type=template&id=0a7ba980&scoped=true"
import script from "./RichMenuAnalyticsPanel.vue?vue&type=script&lang=js"
export * from "./RichMenuAnalyticsPanel.vue?vue&type=script&lang=js"

import "./RichMenuAnalyticsPanel.vue?vue&type=style&index=0&id=0a7ba980&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7ba980"]])

export default __exports__